import { GetStaticProps, NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { useDocumentDataOnce } from 'react-firebase-hooks/firestore'
import { TermsList } from 'web_core/assets/term/List'
import {
  TermsWithGlossaryInfo,
  getDoc,
  termsWithGlossaryInfoConverter,
  termsWithGlossaryInfoRef,
} from 'web_core/firebase'
import { Serialized, deserialize, serialize } from 'web_core/utils'
import { addLocaleProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'

type Props = {
  terms: Serialized<TermsWithGlossaryInfo> | null
}

export const getStaticProps: GetStaticProps<Props> = async ({
  locale = 'ja',
}) => {
  const snapshot = await getDoc(termsWithGlossaryInfoRef(locale))
  const termsWithGlossaryInfo = snapshot.data()
  const result = {
    props: {
      terms: termsWithGlossaryInfo ? serialize(termsWithGlossaryInfo) : null,
    },
    revalidate: 10,
  }
  return addLocaleProps(result, locale)
}

const Page: NextPage<Props> = ({ terms: staticTerms }) => {
  const { i18n } = useTranslation()
  const [termsWithGlossaryInfo] = useDocumentDataOnce(
    termsWithGlossaryInfoRef(i18n.language),
    {
      initialValue: staticTerms
        ? deserialize(staticTerms, { ref: termsWithGlossaryInfoConverter })
        : undefined,
    }
  )
  return (
    <DefaultLayout
      head={{
        title: '大学数学の用語の一覧',
        description:
          '本ページでは現代数学の用語の一覧を五十音順で掲載しています。各用語の解説も充実しています。大学数学や現代数学を学んでいる人必見です。',
      }}
      categoriesMenu={{ pc: true, sp: true, spFixed: true }}
      leftSidebar
      rightSideBar
    >
      <div className="mathdown-monotone">
        <h1>現代数学の用語の一覧</h1>
        <TermsList terms={termsWithGlossaryInfo?.data ?? []} />
      </div>
    </DefaultLayout>
  )
}

export default Page
